import { EndReason, GameResult } from "./GameHistory";
import { Seat } from "./GameClock";

// Rematches and series (docs/specs/rematch).

// One finished game of a series. Seats, not user ids: the players keep their seats through a series.
export interface SeriesGame {
    gameId: string;
    firstSeat: Seat;
    // Null when the game ended without a winner.
    result: GameResult | null;
    endReason: EndReason;
    player1Store: number;
    player2Store: number;
}

// A game and the rematches after it; `games` are the finished ones, oldest first.
export interface Series {
    id: string;
    games: SeriesGame[];
}

// on_rematch_request: the opponent asks for a rematch of the game that ended.
export interface RematchRequest {
    gameId: string;
}

// declined: the opponent said no; withdrawn: the player who asked took it back; expired: no answer within a minute;
// offline: a player went offline; left: a player looked for another game; closed: a rematch is no longer possible.
export type RematchEndReason = "declined" | "withdrawn" | "expired" | "offline" | "left" | "closed";

// on_rematch_ended, to both players.
export interface RematchEnded {
    gameId: string;
    reason: RematchEndReason;
}

// After these, the series is over and only a new game is offered.
export function isSeriesOver(reason: RematchEndReason): boolean {
    return reason === "declined" || reason === "left" || reason === "closed";
}

export interface SeriesScore {
    // Games won by the seat and by the other seat; draws and games without a winner count for neither.
    wins: number;
    losses: number;
}

export function getSeriesScore(games: SeriesGame[], seat: Seat): SeriesScore {
    const wins = games.filter((game) => game.result === seat).length;
    const losses = games.filter((game) => game.result !== null && game.result !== "draw" && game.result !== seat).length;
    return { wins, losses };
}
